import { Layout } from 'antd';

import IdeaChannelHeader from '../idea-channel-layout/Header';
import IdeaChannelSideMenu from '../idea-channel-layout/SideMenu';
import { ReactElement } from 'react';

const { Content } = Layout;
/* eslint-disable-next-line */

export type PLATFORM_TYPES = 'ADMIN' | 'PLATFORM';

export function IdeaChannelLayout({
  children,
  type,
}: {
  children: ReactElement;
  type: PLATFORM_TYPES;
}) {
  return (
    <Layout>
      <IdeaChannelSideMenu type={type} />
      <Layout>
        <IdeaChannelHeader />
        <Content
          style={{
            padding: 16,
            height: `calc(100vh - 64px)`,
            background: '#f5f5f5',
            overflow: 'auto',
          }}
        >
          {children}
        </Content>
      </Layout>
    </Layout>
  );
}

export default IdeaChannelLayout;
